var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Add = function Add(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 40.88 40.88' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('defs', null),
      React.createElement(
        'title',
        null,
        'icon 2'
      ),
      React.createElement('path', { d: 'M266.5 463a20.44 20.44 0 1 0 20.44 20.44A20.46 20.46 0 0 0 266.5 463zm0 39.88a19.44 19.44 0 1 1 19.44-19.44 19.46 19.46 0 0 1-19.44 19.44z',
        transform: 'translate(-246.05 -462.99)', className: 'cls-1' }),
      React.createElement('path', { d: 'M20.95 13.01h-1V20h-7v1h7v7h1v-7h7v-1h-7v-6.99z', className: 'cls-1' })
    )
  );
};
/*eslint-enable */

export default Add;
//# sourceMappingURL=Add.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Add.js